import React from 'react';

const People: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    height="17"
    fill="none"
    viewBox="0 0 16 17"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d={`M10.6367 9.78125C11.7109 9.78125 12.6289 10.1719 13.3906
        10.9531C14.1719 11.7148 14.5625 12.6328 14.5625 13.707V14.4688C14.5625
        14.8594 14.4258 15.1914 14.1523 15.4648C13.8789 15.7383 13.5469 15.875
        13.1562 15.875H2.84375C2.45312 15.875 2.12109 15.7383 1.84766
        15.4648C1.57422 15.1914 1.4375 14.8594 1.4375 14.4688V13.707C1.4375
        12.6328 1.81836 11.7148 2.58008 10.9531C3.36133 10.1719 4.28906 9.78125
        5.36328 9.78125C5.61719 9.78125 5.98828 9.85938 6.47656 10.0156C6.98438
        10.1719 7.49219 10.25 8 10.25C8.50781 10.25 9.01562 10.1719 9.52344
        10.0156C10.0312 9.85938 10.4023 9.78125 10.6367 9.78125ZM13.1562
        14.4688V13.707C13.1562 13.0234 12.9023 12.4375 12.3945 11.9492C11.9062
        11.4414 11.3203 11.1875 10.6367 11.1875C10.5781 11.1875 10.2656 11.2656
        9.69922 11.4219C9.15234 11.5781 8.58594 11.6562 8 11.6562C7.41406 11.6562
        6.83789 11.5781 6.27148 11.4219C5.72461 11.2656 5.42188 11.1875 5.36328
        11.1875C4.67969 11.1875 4.08398 11.4414 3.57617 11.9492C3.08789 12.4375
        2.84375 13.0234 2.84375 13.707V14.4688H13.1562ZM10.9883 8.08203C10.168
        8.90234 9.17188 9.3125 8 9.3125C6.82812 9.3125 5.83203 8.90234 5.01172
        8.08203C4.19141 7.26172 3.78125 6.26562 3.78125 5.09375C3.78125 3.92188
        4.19141 2.92578 5.01172 2.10547C5.83203 1.28516 6.82812 0.875
        8 0.875C9.17188 0.875 10.168 1.28516 10.9883 2.10547C11.8086 2.92578
        12.2188 3.92188 12.2188 5.09375C12.2188 6.26562 11.8086 7.26172 10.9883
        8.08203ZM9.99219 3.10156C9.44531 2.55469 8.78125 2.28125 8 2.28125C7.21875
        2.28125 6.55469 2.55469 6.00781 3.10156C5.46094 3.64844 5.1875 4.3125
        5.1875 5.09375C5.1875 5.875 5.46094 6.53906 6.00781 7.08594C6.55469
        7.63281 7.21875 7.90625 8 7.90625C8.78125 7.90625 9.44531 7.63281 9.99219
        7.08594C10.5391 6.53906 10.8125 5.875 10.8125 5.09375C10.8125 4.3125
        10.5391 3.64844 9.99219 3.10156Z`} fill="#C5D0DE"
    />
  </svg>
);

export default People;
